<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>渠道资源情况</span>
          </div>

          <el-form
            :model="searchData"
            label-width="10em"
            :inline="true"
            v-if="isAccessUser"
          >
            <el-form-item label="浏览人员设置">
              <el-select
                v-model="searchData.view_userid"
                clearable
                filterable>
                <el-option-group
                  v-for="(group, index) in constDict.view_userid"
                  :key="index"
                  :label="group.label">
                  <el-option
                    v-for="v in group.options"
                    :key="v.value"
                    :label="v.label"
                    :value="v.value"/>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchAction">搜索</el-button>
            </el-form-item>
          </el-form>

          <jm-tableList
            :url="url"
            :refresh.sync="refresh"
            :search-data="searchData"
            :no-pagination="true"
          >
          </jm-tableList>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BiBarLine from '@/components/charts/biBarLine';
import { getAdvisoryTeachers } from '@/api/teacher';
import jmTableList from '@/components/data/tableList';
import common from '@/pages/bi/common';
import { jmChannel } from '@/components/tool';
import dataList from '@/pages/h5/compoments/dataList';

export default {
  mixins: [common],
  data() {
    return {
      chartsData: {
        refresh: 1
      },
      chartsSort: {
        options: [],
        value: '资源数'
      },
      constDict: {
        view_userid: []
      },
      refresh: false,
      formData: {},
      searchData: {
        gid: '',
        teacher_id: [],
        timeline: [],
        roleid: null,
        center_member: this.$store.state.userinfo.userid
      },
      url: '/index/b_i_channel/getChannelResourceList',
    };
  },
  components: {
    BiBarLine, getAdvisoryTeachers, jmChannel, jmTableList, dataList
  },
  created() {
    this.$http._get({
      url: '/index/b_i_channel/getDict'
    })
      .then(({ data }) => {
        this.constDict = {
          view_userid: data.view_users || []
        };
      });
    this.refresh = true;
  },
  computed: {
    isAccessUser() {
      return this.$hasPermission(62);
    }
  },
  methods: {
    searchAction() {
      this.refresh = true;
    }
  }
};

</script>

<style scoped>

</style>
